import { useContext } from 'react';

import EditingStateContext, { type EditingStateContextType } from './EditingStateContext';

const useEditingState = (): EditingStateContextType => {
  const context = useContext(EditingStateContext);
  // The context will always have a value due to the default context,
  // but we need to check if it's the unimplemented version
  try {
    context.isFieldBeingEdited('test');
    return context;
  } catch (error) {
    if (error instanceof Error && error.message === 'EditingStateContext not implemented') {
      throw new Error('useEditingState must be used within an EditingStateProvider');
    }
    throw error;
  }
};

export default useEditingState;
